import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('submit', '.page-header-search-form', fn.handleSearch)
  },

  handleSearch: (e) => {
    const data = new FormData(e.target)
    let hasValues = false

    for (const v of data.values()) {
      if (v !== '') {
        hasValues = true
      }
    }

    if (!hasValues) {
      e.preventDefault()
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
